import React from 'react';

import { L10n } from '~commonInfra/L10n/L10n';

import { dropdownListItemLeftAligned, dropdownListItemRightAligned } from './FilterPanelStyles';


export function ListItemContentWithCount(props: { label: string, count: number }) {
  return <>
    <span className={dropdownListItemLeftAligned}>{props.label}</span>
    <span className={dropdownListItemRightAligned}>{L10n.localizedCount(props.count)}</span>
  </>;
}
